import React, { useState, useEffect } from "react";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // This function will be attached to the scrollable container
  const toggleVisibility = () => {
    // Find the main scrollable container by its ID
    const scrollableElement = document.getElementById("main-content-scroll");
    if (scrollableElement) {
      // If the user has scrolled more than 300px, show the button
      if (scrollableElement.scrollTop > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }
  };

  // This function will be called when the button is clicked
  const scrollToTop = () => {
    const scrollableElement = document.getElementById("main-content-scroll");
    if (scrollableElement) {
      // Smoothly scroll the container to the top
      scrollableElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const scrollableElement = document.getElementById("main-content-scroll");
    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", toggleVisibility);
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener("scroll", toggleVisibility);
      }
    };
  }, []);

  return (
    <div className="fixed bottom-20 right-10 z-50">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="p-3 rounded-full bg-gray-800 text-white shadow-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-all duration-300 ease-in-out transform hover:scale-110"
          aria-label="Go to top"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 15l7-7 7 7"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ScrollToTopButton;
